import React, { useState } from "react";
import menuItem1 from "../assets/img/menu/menu-item-1.png";
import menuItem2 from "../assets/img/menu/menu-item-2.png";
import menuItem3 from "../assets/img/menu/menu-item-3.png";
import menuItem4 from "../assets/img/menu/menu-item-4.png";
import menuItem5 from "../assets/img/menu/menu-item-5.png";
import menuItem6 from "../assets/img/menu/menu-item-6.png";


const Menu = () => {

  const [searchTerm, setSearchTerm] = useState("");

  const menuItems = [
    {
      image: menuItem1,
      title: "Magnam Tiste",
      price: "$5.95"
    },
    {
      image: menuItem2,
      title: "Aut Luia",
      price: "$14.95"
    },
    {
      image: menuItem3,
      title: "Est Eligendi",
      price: "$8.95"
    },
    {
      image: menuItem4,
      title: "Eos Luibusdam",
      price: "$12.95"
    },
    {
      image: menuItem5,
      title: "Cheese Pizza",
      price: "$10.95"
    },
    {
      image: menuItem6,
      title: "Chicken Burger",
      price: "$9.95"
    }
  ];



  const filteredItems = menuItems.filter((item) =>
    item.title
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const matchesSearch = (title) => {
    return title.toLowerCase().includes(searchTerm.toLowerCase());
  };

  const hasResults =
    matchesSearch("Magnam Tiste") ||
    matchesSearch("Aut Luia") ||
    matchesSearch("Est Eligendi") ||
    matchesSearch("Eos Luibusdam") ||
    matchesSearch("Cheese Pizza") ||
    matchesSearch("Chicken Burger");

  return (
    <React.Fragment>

      <section id="menu" class="menu section">

        <div class="container section-title" data-aos="fade-up">
          <h2>Our Menu</h2>
          <p><span>Check Our</span> <span class="description-title">Yummy Menu</span></p>
        </div>

        <div class="container">

          <div className="container mb-4">
            <div className="row justify-content-center">
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search food..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>

          <ul class="nav nav-tabs d-flex justify-content-center" data-aos="fade-up" data-aos-delay="100">

            <li class="nav-item">
              <a class="nav-link active show" data-bs-toggle="tab" data-bs-target="#menu-starters">
                <h4>Starters</h4>
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" data-bs-target="#menu-breakfast">
                <h4>Breakfast</h4>
              </a>

            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" data-bs-target="#menu-lunch">
                <h4>Lunch</h4>
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" data-bs-target="#menu-dinner">
                <h4>Dinner</h4>
              </a>
            </li>

          </ul>

          <div class="tab-content" data-aos="fade-up" data-aos-delay="200">

            <div class="tab-pane fade active show" id="menu-starters">

              <div class="tab-header text-center">
                <p>Menu</p>
                <h3>Starters</h3>
              </div>

              <div class="row gy-5">

                {matchesSearch("Magnam Tiste") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-1.png" class="glightbox"><img src={menuItem1}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Magnam Tiste</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $5.95
                    </p>
                  </div>
                )}

                {matchesSearch("Aut Luia") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-2.png" class="glightbox"><img src={menuItem2}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Aut Luia</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $14.95
                    </p>
                  </div>
                )}

                {matchesSearch("Est Eligendi") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-3.png" class="glightbox"><img src={menuItem3}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Est Eligendi</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $8.95
                    </p>
                  </div>
                )}

                {matchesSearch("Eos Luibusdam") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-4.png" class="glightbox"><img src={menuItem4}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Eos Luibusdam</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $12.95
                    </p>
                  </div>
                )}

                {matchesSearch("Eos Luibusdam") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-5.png" class="glightbox"><img src={menuItem5}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Eos Luibusdam</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $12.95
                    </p>
                  </div>
                )}

                {matchesSearch("Laboriosam Direva") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-6.png" class="glightbox"><img src={menuItem6}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Laboriosam Direva</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $9.95
                    </p>
                  </div>
                )}

              </div>
            </div>

            <div class="tab-pane fade" id="menu-breakfast">

              <div class="tab-header text-center">
                <p>Menu</p>
                <h3>Breakfast</h3>
              </div>

              <div class="row gy-5">

                {matchesSearch("Magnam Tiste") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-1.png" class="glightbox"><img src={menuItem1}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Magnam Tiste</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $5.95
                    </p>
                  </div>
                )}

                {matchesSearch("Aut Luia") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-2.png" class="glightbox"><img src={menuItem2}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Aut Luia</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $14.95
                    </p>
                  </div>
                )}

                {matchesSearch("Est Eligendi") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-3.png" class="glightbox"><img src={menuItem3}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Est Eligendi</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $8.95
                    </p>
                  </div>
                )}

                {matchesSearch("Eos Luibusdam") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-4.png" class="glightbox"><img src={menuItem4}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Eos Luibusdam</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $12.95
                    </p>
                  </div>
                )}

                {matchesSearch("Eos Luibusdam") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-5.png" class="glightbox"><img src={menuItem5}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Eos Luibusdam</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $12.95
                    </p>
                  </div>
                )}

                {matchesSearch("Laboriosam Direva") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-6.png" class="glightbox"><img src={menuItem6}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Laboriosam Direva</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $9.95
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div class="tab-pane fade" id="menu-lunch">

              <div class="tab-header text-center">
                <p>Menu</p>
                <h3>Lunch</h3>
              </div>

              <div class="row gy-5">

                {matchesSearch("Magnam Tiste") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-1.png" class="glightbox"><img src={menuItem1}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Magnam Tiste</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $5.95
                    </p>
                  </div>
                )}

                {matchesSearch("Aut Luia") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-2.png" class="glightbox"><img src={menuItem2}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Aut Luia</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $14.95
                    </p>
                  </div>
                )}

                {matchesSearch("Est Eligendi") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-3.png" class="glightbox"><img src={menuItem3}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Est Eligendi</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $8.95
                    </p>
                  </div>
                )}

                {matchesSearch("Eos Luibusdam") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-4.png" class="glightbox"><img src={menuItem4}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Eos Luibusdam</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $12.95
                    </p>
                  </div>
                )}

                {matchesSearch("Eos Luibusdam") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-5.png" class="glightbox"><img src={menuItem5}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Eos Luibusdam</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $12.95
                    </p>
                  </div>
                )}

                {matchesSearch("Laboriosam Direva") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-6.png" class="glightbox"><img src={menuItem6}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Laboriosam Direva</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $9.95
                    </p>
                  </div>
                )}

              </div>
            </div>

            <div class="tab-pane fade" id="menu-dinner">

              <div class="tab-header text-center">
                <p>Menu</p>
                <h3>Dinner</h3>
              </div>

              <div class="row gy-5">

                {matchesSearch("Magnam Tiste") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-1.png" class="glightbox"><img src={menuItem1}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Magnam Tiste</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $5.95
                    </p>
                  </div>
                )}

                {matchesSearch("Aut Luia") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-2.png" class="glightbox"><img src={menuItem2}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Aut Luia</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $14.95
                    </p>
                  </div>
                )}

                {matchesSearch("Est Eligendi") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-3.png" class="glightbox"><img src={menuItem3}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Est Eligendi</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $8.95
                    </p>
                  </div>
                )}

                {matchesSearch("Eos Luibusdam") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-4.png" class="glightbox"><img src={menuItem4}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Eos Luibusdam</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $12.95
                    </p>
                  </div>
                )}

                {matchesSearch("Eos Luibusdam") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-5.png" class="glightbox"><img src={menuItem5}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Eos Luibusdam</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $12.95
                    </p>
                  </div>
                )}

                {matchesSearch("Laboriosam Direva") && (

                  <div class="col-lg-4 menu-item">
                    <a href="assets/img/menu/menu-item-6.png" class="glightbox"><img src={menuItem6}
                      class="menu-img img-fluid" alt="" /></a>
                    <h4>Laboriosam Direva</h4>
                    <p class="ingredients">
                      Lorem, deren, trataro, filede, nerada
                    </p>
                    <p class="price">
                      $9.95
                    </p>
                  </div>
                )}

              </div>
            </div>

            {!hasResults && (
              <div className="text-center mt-4">
                <h4 className="text-danger">
                  No Food Found
                </h4>
              </div>
            )}

          </div>

        </div>

      </section>
    </React.Fragment>
  )
}

export default Menu;